import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";

export interface EconomicState {
  hasIntegration: boolean;
  isLoading: boolean;
  error: string | null;
}

const initialState: EconomicState = {
  hasIntegration: false,
  isLoading: true,
  error: null,
};

export const checkEconomicIntegration = createAsyncThunk(
  "economic/checkIntegration",
  async () => {
    const { data } = await axios.get<{ has_integration: boolean }>(
      "/v1/integrations/economic/status/",
    );
    return data.has_integration;
  },
);

const economicSlice = createSlice({
  name: "economic",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(checkEconomicIntegration.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(checkEconomicIntegration.fulfilled, (state, action) => {
        state.hasIntegration = action.payload;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(checkEconomicIntegration.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Failed to check integration";
      });
  },
});

export default economicSlice.reducer;
